import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, lastValueFrom, firstValueFrom } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { datePickerMinDate } from '../../shared/constants';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { DomSanitizer } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { HttpErrorResponse } from '@angular/common/http';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-followup-report',
	templateUrl: './followup-report.component.html',
	styleUrl: './followup-report.component.scss'
})
export class FollowupReportComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	uId: any = null;
	followId: any = null;
	followUpDetails: any = null;
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	downloadLoader = false;
	pagetitle: string = "Follow-up Report";
	moduleForm!: FormGroup;
	minDate = datePickerMinDate;
	formSubmitted = false;
	saveLoader = false;
	showReport = false;
	fileURL: any = null;
	prevFollList: any[] = [];
	/* doctortList: any = []; */

	/* otpFormLoader = false;
	showOTP = false;
	otpFormSubmitted = false;
	otpForm: FormGroup = this.formBuilder.group({
		reason: [null, [Validators.required]],
		otp: [null]
	});
	get f1() { return this.otpForm.controls }
	customErrorOTP: any = {};
	otpMailId: any = ""; */

	constructor(private sanitizer: DomSanitizer, private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.resetForm();
	}
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["caseId"];
			this.followId = routeParams["followId"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/" + this.followId, name: "Appointment Details", queryparams: { "follow-up": this.followId } });
			this.breadcrumbList.push({ path: "/app/followup-report/" + this.uId + "/" + this.followId, name: "Follow Report" });
			this.getDetails();
			/* this.getDoctor(); */
			this.getReportPDF();
		});
	}

	getPrevFollowUps() {
		this.pageLoading1 = true;
		this.apiService.getFollowupList({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.prevFollList = data.data.filter((fol: any) => {
					try {
						if (fol.enc_id == this.followId) {
							return false;
						}
						let currFolDate = this.apiService.getDateFromDateString(this.followUpDetails.follow_up_date);
						let folDate = this.apiService.getDateFromDateString(fol.follow_up_date);
						if (currFolDate >= folDate && fol.follow_up_status && fol.follow_up_status.id != 1 && fol.visit_type && fol.visit_type.id != 5) {
							return true;
						}
						return false;
					} catch (error) {
						return false;
					}
				});
			}, error: (error) => {
				this.pageLoading1 = false;
				this.prevFollList = [];
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getFollowUpStatusClass(statusId: any) {
		if (statusId == 2) {
			return "bg-success";
		} else if (statusId == 1) {
			return "bg-warning";
		} else {
			return "bg-danger";
		}
	}

	resetForm() {
		this.moduleForm = this.formBuilder.group({
			expected_treatment_period: [null],
			expected_treatment_cost: [null],
			further_advice: [null],
			fitness_status: [null],
			report_no: [null, [Validators.required/* , Validators.pattern(/^\d+$/) */]],
			next_review_date: [null],
			due_to: [null],
			previous_followups: [[]],
			followup_report_sent: [false],
			faq: this.formBuilder.array([])
			/* doctor_1_id: [null, [Validators.required]],
			doctor_2_id: [null, [Validators.required]] */
		});
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['faq'] as FormArray;
	}

	addRow(valueObj: any = null) {
		const form = this.formBuilder.group({
			id: [valueObj?.id || null, [Validators.required]],
			question: [valueObj?.question || null, [Validators.required]],
			answer: [valueObj?.answer || null]
		});
		this.get_rows.push(form);
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	/* getDoctor() {
		this.apiService.getDoctor({}).subscribe({
			next: (data: any) => {
				this.doctortList = data.data;
			}, error: (error) => {
				this.doctortList = [];
			},
		});
	} */

	getDetails() {
		this.pageLoading2 = true;
		this.apiService.getFollowupDetails(this.followId).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.followUpDetails = data.data;
				this.resetForm();
				this.f.expected_treatment_period.setValue(this.followUpDetails.expected_treatment_period);
				this.f.expected_treatment_cost.setValue(this.followUpDetails.expected_treatment_cost);
				this.f.further_advice.setValue(this.followUpDetails.further_advice);
				this.f.fitness_status.setValue(this.followUpDetails.fitness_status);
				this.f.due_to.setValue(this.followUpDetails.due_to);
				this.f.previous_followups.setValue(this.followUpDetails.previous_followups);
				this.f.followup_report_sent.setValue(this.followUpDetails.followup_report_sent);
				this.f.report_no.setValue(this.followUpDetails.report_no);
				this.f.next_review_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.next_review_date));
				/* this.f.doctor_1_id.setValue(this.followUpDetails.doctor_1);
				this.f.doctor_2_id.setValue(this.followUpDetails.doctor_2); */
				let faq = this.followUpDetails.faq;
				let len = this.followUpDetails.faq.length;
				for (let i = 0; i < len; i++) {
					this.addRow(faq[i]);
				}
				if (this.navbar.userAccess?.Follow_up_report != 'Full') {
					this.moduleForm.disable();
				}
				this.getPrevFollowUps();
			}, error: (error) => {
				this.pageLoading2 = false;
				this.followUpDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	saveReport_A() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.error("Please check required fields", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.saveReport_B();
		/* const followup = this.getChangedFollowupNotes();
		if (followup.length) {
			this.otpVerification();
		} else {
			this.saveReport_B();
		} */
	}

	saveReport_B() {
		let payload: any = {
			id: this.followId,
			expected_treatment_period: this.f.expected_treatment_period.value,
			expected_treatment_cost: this.f.expected_treatment_cost.value,
			further_advice: this.f.further_advice.value,
			fitness_status: this.f.fitness_status.value,
			due_to: this.f.due_to.value,
			previous_followups: this.f.previous_followups.value,
			followup_report_sent: this.f.followup_report_sent.value,
			report_no: this.f.report_no.value,
			next_review_date: this.apiService.getDateStringFromDate(this.f.next_review_date.value) || null,
			/* doctor_1_id: this.f.doctor_1_id.value,
			doctor_2_id: this.f.doctor_2_id.value, */
		}
		let faq: any[] = [];
		for (let i = 0; i < this.get_rows.controls.length; i++) {
			faq.push({
				id: this.get_rows.controls[i].get("id")?.value,
				question: this.get_rows.controls[i].get("question")?.value,
				answer: this.get_rows.controls[i].get("answer")?.value
			});
		}
		payload.faq = faq;
		this.saveLoader = true;
		this.apiService.saveFollowUpReport(payload).subscribe({
			next: (data: any) => {
				this.saveLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getDetails();
				this.getReportPDF();
			}, error: (error) => {
				this.saveLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	/* clearOTPForm() {
		this.otpForm.reset();
		this.showOTP = false;
		this.otpMailId = "";
		this.f1["reason"].enable();
		this.f1["otp"].setValidators(null);
		this.f1["otp"].updateValueAndValidity();
	}

	otpVerification() {
		this.clearOTPForm();
		$("#otpModalReport").modal("show");
	}

	showOTPFormError(field: string) {
		if (this.f1[field].invalid && (this.otpFormSubmitted || this.f1[field].touched || this.f1[field].dirty)) {
			return true;
		}
		return false;
	}

	clearCustomErrorOTP() {
		Object.keys(this.f1).forEach(key => {
			if (this.f1[key].hasError('incorrect')) {
				try {
					delete this.f1[key].errors?.incorrect;
					this.f1[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customErrorOTP = {};
	}

	getOTPPayload() {
		return {
			"type": "report",
			"field": "notes",
			"reason": this.f1["reason"].value
		}
	}

	getOTP() {
		this.otpFormSubmitted = true;
		this.clearCustomErrorOTP();
		if (this.otpForm.invalid) {
			this.toastr.error('Please check required parameters', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = this.getOTPPayload();
		this.otpFormLoader = true;
		this.apiService.getOTP(payload).subscribe({
			next: (data: any) => {
				this.otpFormLoader = false;
				this.showOTP = true;
				this.otpMailId = data;
				this.f1["reason"].disable();
				this.f1["otp"].setValidators([Validators.required]);
				this.f1["otp"].updateValueAndValidity();
				this.otpFormSubmitted = false;
				this.toastr.success('OTP sent successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.otpFormLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	} */

	/* verifyOTP() {
		this.otpFormSubmitted = true;
		this.clearCustomErrorOTP();
		if (this.otpForm.invalid) {
			this.toastr.error('Please check required parameters', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = this.getOTPPayload();
		payload["otp"] = this.f1["otp"].value;
		this.otpFormLoader = true;
		this.apiService.verifyOTP(payload).subscribe({
			next: (data: any) => {
				this.otpFormLoader = false;
				this.clearOTPForm();
				this.toastr.success('OTP verified successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				$("#otpModalReport").modal("hide");
				this.saveReport_B();
			}, error: (error) => {
				this.otpFormLoader = false;
				this.f1.otp.setErrors({ incorrect: true });
				this.customErrorOTP.otp = "Invalid OTP";
			}
		});
	} */

	downloadReport() {
		/* Swal.fire({
			title: "Verify Password",
			input: "password",
			inputLabel: "Enter Password",
			inputAttributes: {
				autocapitalize: "off"
			},
			showCancelButton: true,
			confirmButtonText: "Verify",
			showLoaderOnConfirm: true,
			backdrop: true,
			allowOutsideClick: () => !Swal.isLoading(),
			preConfirm: async (password) => {
				try {
					const responseFlag = await firstValueFrom(this.apiService.verifyPassword({ password: password }));
					if (responseFlag) {
						this.toastr.success("Password verified successfully", 'Success', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					} else {
						Swal.showValidationMessage('Invalid Password');
					}
					return responseFlag
				} catch (error) {
					Swal.showValidationMessage('Invalid Password');
					return false;
				}
			}
		}).then((result) => {
			if (result.isConfirmed) {
				this.getReportPDF(true);
			}
		}); */
		this.getReportPDF(true);
	}

	getReportPDF(isDownload = false) {
		if (isDownload) {
			this.downloadLoader = true;
		} else {
			this.pageLoading3 = true;
		}
		this.apiService.followUpReportPDF({ "id": this.followId/* , "flag": isDownload */ }).subscribe({
			next: (data: any) => {
				let blob = new Blob([data.body], { type: "application/pdf" });
				if (isDownload) {
					const f_name = this.followUpDetails.case_id.candidate.f_name;
					const l_name = this.followUpDetails.case_id.candidate.l_name;
					let report_no = this.followUpDetails.report_no;
					if (report_no) {
						report_no = " " + report_no;
					} else {
						report_no = "";
					}
					let file_name = f_name + " " + l_name + report_no + ".pdf";
					FileSaver.saveAs(blob, file_name);
					this.downloadLoader = false;
				} else {
					this.pageLoading3 = false;
					this.showReport = true;
					this.fileURL = this.getSafeUrl(URL.createObjectURL(blob) + "#toolbar=0");
				}
			}, error: (error) => {
				if (isDownload) {
					this.downloadLoader = false;
				} else {
					this.pageLoading3 = false;
					this.showReport = false;
				}
				this.showErrorPopup(error, isDownload);
			}
		});
	}

	showErrorPopup(error: any, isDownload: boolean) {
		if (error.status == 400) {
			let msg = "Please save report details to generate report.";
			if (isDownload) {
				this.toastr.error(msg, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			} else {
				Swal.fire({ title: "Note", text: msg });
			}
		} else {
			this.toastr.error("Unable to fetch report", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}
}
